import 'babel-polyfill';
import { Pagination, Message, Loading,Dropdown,DropdownMenu,DropdownItem,Avatar,Popover ,Form,FormItem,Input,Button,Dialog,Table,TableColumn} from 'element-ui';
import Vue from 'vue';
import App from './App.vue';
// require('@/plugins/Qiniu/qiniuUpload.min.js')
// require('@/plugins/Qiniu/qiniu.min.js')

import router from './router';

import store from './store';

import filters from './utils/filter.js'; // 注册过滤器

import { AXIOSWAYS, ApiInfo } from './utils/server.js';

import Common from './utils/common.js';

import './assets/less/main.less';
import './assets/js/qrcode.min.js'

Object.keys(filters).forEach(k => { // 注册过滤器
  Vue.filter(k, filters[k])
})

Vue.config.productionTip = false;

Vue.prototype.$axios = AXIOSWAYS;
Vue.prototype.$ApiInfo = ApiInfo;
Vue.prototype.$Common = Common;

// Common.initFontSize();
// Common.watchFontSize();
Vue.use(Pagination).use(Dropdown).use(DropdownItem).use(DropdownMenu).use(Avatar).use(Popover).use(Form).use(FormItem).use(Input).use(Button).use(Dialog).use(Table).use(TableColumn)
Vue.use(Loading.directive);
Vue.prototype.$bus = new Vue();
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;
Vue.prototype.setMetaInfo = function (
  title,
  description,
  imgs_url
  ) {
    document.title = title || '中国航空新闻网'
    document.querySelector('meta[name="Description"]').setAttribute('content', description || '中国航空新闻网（Can News）隶属于《中国航空报》社有限公司（CAN Press），是航空行业第一新闻门户网站，主要内容包含航空制造业、民航运输、军事防务、MRO、通用及商务航空、科技前沿、图集、视频、策划专题及会展活动等。旗下看航空IP是行业知名新媒体矩阵品牌，产品覆盖微信、微博、今日头条、网易、搜狐、腾讯、凤凰网、百度、一点资讯、UC大鱼、优酷、爱奇艺、H5及海报等。')
    document.querySelector('meta[property="og:image"]').setAttribute('content', (imgs_url || 'https://hkqg-static.hangkong.com.cn/cdn/web/img/default_4_3.d184a7a7.png').split(";")[0])
}
Vue.prototype.getDescription = function (str = '') {
  const htmlTemplate = document.createElement('div');
  htmlTemplate.innerHTML = str;
  return (htmlTemplate.innerText || '').slice(0, 100);
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
